/**
 * One backend, one base URL. Set per environment in .env.<mode>.
 * Falls back to the local backend so a fresh checkout runs without any .env file.
 */
export const apiUrl: string =
  import.meta.env.VITE_MOBILE_SHOP_API_URL || 'http://localhost:8095';

export const basePath = '/mobile-shop/v1';
